export const INITIAL = 'Initial' // Inicial
export const ESTABLISHING = 'Establishing' // Estabelecendo
export const ESTABLISHED = 'Established' // Estabelecido/Conectado
export const TERMINATING = 'Terminating' // Terminando
export const TERMINATED = 'Terminado' // Terminado/Finalizado
